import { API_HOST_NAME } from '../../constants.js'
import useAuthenticatedResources from '../../../../useAuthenticatedResources.js'

const additionalActions = [
  { name: 'import', member: true, method: 'POST' },
  { name: 'edit', member: true, method: 'GET' }
]

const useTeamPackageImportsResources = (teamId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/package_imports`
  return useAuthenticatedResources(url, {}, additionalActions)
}

export default useTeamPackageImportsResources
